import { $axios } from '@/modules/http/axios'
import emitter from '@/modules/events/emitter'

const statisticsModule = {
  namespaced: true,

  state: () => ({
    vehicles: [],
    trailers: [],
    drivers: [],
    errorsBag: []
  }),

  getters: {
    getDrivers (state) {
      return state.drivers
    },

    getVehicles (state) {
      return state.vehicles
    },

    getTrailers (state) {
      return state.trailers
    },

    getErrorsBag (state) {
      return state.errorsBag
    }
  },

  mutations: {
    setDrivers (state, drivers) {
      state.drivers = drivers
    },

    setVehicles (state, vehicles) {
      state.vehicles = vehicles
    },

    setTrailers (state, trailers) {
      state.trailers = trailers
    },

    pushError (state, error) {
      state.errorsBag.push(error)
    },

    clearErrorBag (state) {
      state.errorsBag = []
    }
  },

  actions: {
    fetchDrivers ({ commit, state }) {
      $axios.get('Driver').then(r => {
        commit('setDrivers', r.data)
        commit('clearErrorBag')
      }).catch(() => {
        commit('pushError', 'Błąd statystyk, proszę odświeżyć magazyn')
      })
    },

    fetchVehicles ({ commit, state }) {
      $axios.get('Vehicle').then(r => {
        commit('setVehicles', r.data.filter(v => !v.hidden))
        commit('clearErrorBag')
      }).catch(() => {
        commit('pushError', 'Błąd statystyk, proszę odświeżyć magazyn')
      })
    },

    fetchTrailers ({ commit, state }) {
      $axios.get('Trailer').then(r => {
        commit('setTrailers', r.data.filter(t => !t.hidden))
        commit('clearErrorBag')
        emitter.emit('countersReady')
      }).catch(() => {
        commit('pushError', 'Błąd statystyk, proszę odświeżyć magazyn')
      })
    }
  }
}

export default statisticsModule
